import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/Support.tsx");
